export const routes = (prefix) => [
    {
        path: `/${prefix}/custom-messages`,
        name: `${prefix}.custom-messages.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.custom-messages.index`,
                PageDescription: "Master Data: Custom messages",
            },
        },
    },
];
